'use client';
import { useSelector } from '@xstate/store/react';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import CartIcon from '@/fo/icons/base/landing/cart.svg';
import NaosLogoWhite from '@/fo/icons/base/landing/naos-logo-white.svg';
import NaosLogo from '@/fo/icons/base/landing/naos-logo.svg';
import { storeProduct, selectCounterCart } from '@/fo/store/product';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './UiLandingHeaderBioderma.styles';

export interface UiLandingHeaderBiodermaProps {
  progressColor?: string;
  whiteLogo?: boolean;
  recommendLogoSrc?: string;
}

export function UiLandingHeaderBioderma({
  progressColor,
  whiteLogo = false,
  recommendLogoSrc = staticMediaUrl('landing/logo-recommend.svg')
}: UiLandingHeaderBiodermaProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [progress, setProgress] = useState(0);
  const cartCount = useSelector(storeProduct, selectCounterCart);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      const total = Math.max(docHeight - winHeight, 1);
      setProgress(Math.min(100, Math.max(0, (scrollTop / total) * 100)));
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const slots = styles({ scrolled: isScrolled, whiteLogo });

  return (
    <header className={slots.base()}>
      <Link
        href="/"
        className={slots.logoWr()}
      >
        <NaosLogoWhite className={slots.logoNaosWhite()} />
        <NaosLogo className={slots.logoNaos()} />
        <div className={slots.divider()} />
      </Link>
      <Link href="/bioderma">
        <img
          src={staticMediaUrl('landing/bioderma-logo.png')}
          className={slots.logoBioderma()}
        />
      </Link>
      <div className={slots.cart()}>
        <img
          src={recommendLogoSrc}
          className={slots.logoRecommend()}
        />
        <Link
          href="/cart"
          target="_blank"
        >
          <CartIcon />
          {cartCount > 0 && (
            <span className={slots.cartCounter()}>{cartCount}</span>
          )}
        </Link>
      </div>
      <div
        className={slots.progress()}
        style={{ width: `${progress}%`, borderColor: progressColor }}
      />
    </header>
  );
}
